import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import secureLocalStorage from "react-secure-storage";
import { userReducer } from "../reducers/userReducer";
import { findMenuTitleReducer, getMenuTitlesReducer } from "../reducers/Menu/MenuTitleReducer";
import { findMenuReducer, mainMenuReducer } from "../reducers/Menu/MainMenuReducer";
import { findSubMenuReducer, subMenuReducer } from "../reducers/Menu/SubMenuReducer";
import { finRoleAssignMenuReducer, findUserRoleReducer, getUserRoleReducer } from "../reducers/User/UserRoleReducer";
import { findUserRoleDetailReducer, getUserRoleDetailReducer } from "../reducers/User/UserRoleDetailReducer";
import { findUserProfileReducer, getUserProfileReducer } from "../reducers/User/UserProfileReducer";
import { findCidDetailReducer, findPaymentCidDetailReducer, findWorkPermitDetailReducer, findLcPlcDetailReducer, findPaymentTpnDetailReducer } from "../reducers/ThirdParty/ThirdPartyReducer";
import { getPaymentAdviceCountersReducer, findPaymentAdviceCounterReducer, paymentAdviceCounterResponseReducer } from "../reducers/PaymentAdvice/PaymentAdviceCounterReducer"
import { getPaymentAdviceSystemsReducer } from "../reducers/PaymentAdvice/PaymentAdviceSystemReducer"
import { findPaymentAdviceReducer, getMajorGroupServicesReducer, getGlheadsWithServicesReducer, getPayerTypeReducer } from "../reducers/PaymentAdvice/PaymentAdviceReducer";
import { getSelectedIdsPaymentAdvice, findGlHeadsRewardPaymentReducer, findPrepaymentBalanceReducer, findUserReceiptStockReducer, getCashDenominationsReducer, findIdentityTypePaymentAdviceReducer, getCounterPaymentResponseReducer } from "../reducers/CounterPayment/CounterPaymentReducer";
import { getReceiptMaintenanceReducer } from "../reducers/ReceiptMaintenance/ReceiptMaintenanceReducer";
import { createReconciliationSummary, getReconciliationExcelData, getReconciliationStagingData } from "../reducers/Reconciliation/ReconciliationReducer";
import { getAmendReducer } from "../reducers/ReceiptMaintenance/AmendReducer";
import { getReversalReducer } from "../reducers/ReceiptMaintenance/ReversalReducer";
import { findReprintReducer } from "../reducers/ReceiptMaintenance/ReprintReducer";
import { receiptListReducer } from "../reducers/ReceiptList/ReceiptListReducer";
import { getReconciliationApprovalReducer, findReconciliationApprovalReducer } from "../reducers/Reconciliation/ReconciliationApprovalReducer";
import { getDepositSlipsReducer, getDepositReceiptsReducer, getDepositSlipResponseReducer, getDepositSlipAllUsersReducer } from "../reducers/DepositSlip/DepositSlipReducer";
import { getChequeBounceListReducer } from "../reducers/ChequeBounce/ChequeBounceReducer";
import { getDepositMaintenanceReducer } from "../reducers/DepositMaintenance/DepositMaintenanceReducer";
import { findDepositMaintenanceReducer } from "../reducers/DepositMaintenance/DepositMaintenanceReducer";
import { unmapDepositMaintenanceReducer } from "../reducers/DepositMaintenance/DepositMaintenanceReducer";
import { getInboxNotificationReducer, findInboxNotificationReducer } from "../reducers/Inbox/InboxReducer";
import { getRmaFailedTransactionsReducer, findRmaFailedTransactionReducer, getRmaFailedTransactionResponseReducer } from "../reducers/RMAFailedTransaction/RMAFailedTransactionReducer";


//---------------------- PHASE-2 START----------------------//


//---------------------- PHASE-3 START ----------------------//
import { getTenantTypesReducer } from "../reducers/Master/TenantMasters/TenantTypeReducer";
import { getTenantsReducer } from "../reducers/Master/TenantMasters/TenantReducer";
import { getDepartmentsReducer } from "../reducers/Master/TenantMasters/DepartmentReducer";
import { getDivisionsReducer } from "../reducers/Master/TenantMasters/DivisionReducer";
import { getRevenueOfficesReducer } from "../reducers/Master/LocationMasters/RevenueOfficeReducer";
import { getDzongkhagsReducer } from "../reducers/Master/LocationMasters/DzongkhagReducer";
import { getDungkhagsReducer } from "../reducers/Master/LocationMasters/DungkhagReducer";
import { getGewogsReducer } from "../reducers/Master/LocationMasters/GewogReducer";
import { getVillagesReducer } from "../reducers/Master/LocationMasters/VillageReducer";

import { getCoaGroupsReducer } from "../reducers/Master/CoaMasters/CoaGroupReducer";
import { getConfigOptionsReducer } from "../reducers/Master/CoaMasters/ConfigOptionReducer";
import { getMajorGroupsReducer } from "../reducers/Master/CoaMasters/MajorGroupReducer";
import { getRevenueGroupsReducer } from "../reducers/Master/CoaMasters/RevenueGroupReducer";
import { getRevenueTypesReducer } from "../reducers/Master/CoaMasters/RevenueTypeReducer";
import { getRevenueSubTypesReducer } from "../reducers/Master/CoaMasters/RevenueSubTypeReducer";
import { getRevenueGlHeadsReducer } from "../reducers/Master/CoaMasters/RevenueGlHeadReducer";
import { getRewardPaymentsReducer } from "../reducers/Master/CoaMasters/RewardPaymentReducer";
import { getBanksReducer, findBankReducer } from "../reducers/Master/CoaMasters/BankReducer";
import { getBankBranchesReducer } from "../reducers/Master/CoaMasters/BankBranchReducer";
import { getTenantBankAccountsReducer } from "../reducers/Master/CoaMasters/TenantBankAccountReducer";

import { getRevenueSourcesReducer } from "../reducers/Master/OtherMasters/RevenueSourceReducer";
import { getServicesReducer } from "../reducers/Master/OtherMasters/ServiceReducer";
import { getAdvancePaymentTypesReducer } from "../reducers/Master/OtherMasters/AdvancePaymentTypeReducer";
import { getExternalSystemsReducer } from "../reducers/Master/OtherMasters/ExternalSystemReducer";
import { getTransactionTypesReducer } from "../reducers/Master/OtherMasters/TransactionTypeReducer";
import { getStatusMastersReducer } from "../reducers/Master/OtherMasters/StatusMasterReducer";
import { getPaymentCollectionMethodsReducer } from "../reducers/Master/OtherMasters/PaymentCollectionMethodReducer";
import { getCountriesReducer } from "../reducers/Master/OtherMasters/CountryReducer";
import { getCurrenciesReducer } from "../reducers/Master/OtherMasters/CurrencyReducer";
import { getModeOfPaymentsReducer } from "../reducers/Master/OtherMasters/ModeOfPaymentReducer";

import { getUsersDataReducer, findCurrentUserDataReducer, findCurrentUserTenantReducer, getUserTypesReducer } from "../reducers/UserManagement/User/UserManagementReducer";

import { getCoaServiceMapsReducer } from "../reducers/CoaManagement/CoaMapping/CoaServiceMapReducer";
import { getTenantBankAccountMapsReducer } from "../reducers/CoaManagement/CoaMapping/TenantBankAccountMapReducer";
import { getCoaNonTaxGstMapsReducer } from "../reducers/CoaManagement/CoaMapping/CoaNonTaxGstMapReducer";
import { findGstInvoiceReducer, getGstInvoiceResponseReducer, getGstInvoicesReducer } from "../reducers/GstInvoicing/GstInvoicingReducer";

//---------------------- PHASE-3 END ----------------------//


const appReducer = combineReducers({
  menuTitles: getMenuTitlesReducer,
  findMenuTitle: findMenuTitleReducer,
  mainMenus: mainMenuReducer,
  findMainMenu: findMenuReducer,
  subMenus: subMenuReducer,
  findSubMenu: findSubMenuReducer,
  user: userReducer,
  userTypes: getUserTypesReducer,
  userRoles: getUserRoleReducer,
  findUserRole: findUserRoleReducer,
  findRolebaseAssignMenuList: finRoleAssignMenuReducer,
  userRoleDetails: getUserRoleDetailReducer,
  findUserRoleDetail: findUserRoleDetailReducer,
  userProfiles: getUserProfileReducer,
  findUserProfile: findUserProfileReducer,
  findCidDetail: findCidDetailReducer,
  findPaymentCidDetail: findPaymentCidDetailReducer,
  findWorkPermitDetail: findWorkPermitDetailReducer,
  findLcPlcDetail: findLcPlcDetailReducer,
  findPaymentTpnDetail: findPaymentTpnDetailReducer,
  paymentAdviceCounters: getPaymentAdviceCountersReducer,
  findPaymentAdviceCounter: findPaymentAdviceCounterReducer,
  paymentAdviceCounterResponse: paymentAdviceCounterResponseReducer,
  paymentAdviceSystems: getPaymentAdviceSystemsReducer,
  findPaymentAdvice: findPaymentAdviceReducer,
  identityTypePaymentAdvice: findIdentityTypePaymentAdviceReducer,
  majorGroupServices: getMajorGroupServicesReducer,
  glHeadsWithServices: getGlheadsWithServicesReducer,
  payerTypes: getPayerTypeReducer,
  findGlHeadsRewardPayment: findGlHeadsRewardPaymentReducer,
  findPrepaymentBalance: findPrepaymentBalanceReducer,
  findUserReceiptStock: findUserReceiptStockReducer,
  cashDenominations: getCashDenominationsReducer,
  counterPaymentResponse: getCounterPaymentResponseReducer,
  selectedIdsPaymentAdvice: getSelectedIdsPaymentAdvice,
  reconciliationExcelData: getReconciliationExcelData,
  reconciliationSummary: createReconciliationSummary,
  reconciliationStagingData: getReconciliationStagingData,
  receiptMaintenances: getReceiptMaintenanceReducer,
  receiptLists: receiptListReducer,
  receiptAmend: getAmendReducer,
  receiptReversal: getReversalReducer,
  findReceiptReprint: findReprintReducer,
  depositSlips: getDepositSlipsReducer,
  depositReceipts: getDepositReceiptsReducer,
  reconciliationApprovals: getReconciliationApprovalReducer,
  findReconciliationApproval: findReconciliationApprovalReducer,
  depositSlipResponse: getDepositSlipResponseReducer,
  depositSlipAllUsers: getDepositSlipAllUsersReducer,
  chequeBounceList: getChequeBounceListReducer,
  depositMaintenances: getDepositMaintenanceReducer,
  findDepositMaintenance: findDepositMaintenanceReducer,
  unmapDepositMaintenance: unmapDepositMaintenanceReducer,

  inboxNotifications: getInboxNotificationReducer,
  findInboxNotification: findInboxNotificationReducer,
  rmaFailedTransactions: getRmaFailedTransactionsReducer,
  findRmaFailedTransaction: findRmaFailedTransactionReducer,
  rmaFailedTransactionResponse: getRmaFailedTransactionResponseReducer,

  //---------------------- PHASE-2 START----------------------//


  //---------------------- PHASE-3 START ----------------------//
  tenantTypes: getTenantTypesReducer,
  tenants: getTenantsReducer,
  departments: getDepartmentsReducer,
  divisions: getDivisionsReducer,
  revenueOffices: getRevenueOfficesReducer,
  dzongkhags: getDzongkhagsReducer,
  dungkhags: getDungkhagsReducer,
  gewogs: getGewogsReducer,
  villages: getVillagesReducer,

  coaGroups: getCoaGroupsReducer,
  configOptions: getConfigOptionsReducer,
  majorGroups: getMajorGroupsReducer,
  revenueGroups: getRevenueGroupsReducer,
  revenueTypes: getRevenueTypesReducer,
  revenueSubTypes: getRevenueSubTypesReducer,
  revenueGlHeads: getRevenueGlHeadsReducer,
  rewardPayments: getRewardPaymentsReducer,
  banks: getBanksReducer,
  findBank: findBankReducer,
  bankBranches: getBankBranchesReducer,
  tenantBankAccounts: getTenantBankAccountsReducer,

  revenueSources: getRevenueSourcesReducer,
  services: getServicesReducer,
  advancePaymentTypes: getAdvancePaymentTypesReducer,
  externalSystems: getExternalSystemsReducer,
  transactionTypes: getTransactionTypesReducer,
  statusMasters: getStatusMastersReducer,
  paymentCollectionMethods: getPaymentCollectionMethodsReducer,
  countries: getCountriesReducer,
  currencies: getCurrenciesReducer,
  modeOfPayments: getModeOfPaymentsReducer,

  usersData: getUsersDataReducer,
  findCurrentUserData: findCurrentUserDataReducer,
  findCurrentUserTenant: findCurrentUserTenantReducer,

  coaServiceMaps: getCoaServiceMapsReducer,
  tenantBankAccountMaps: getTenantBankAccountMapsReducer,
  coaNonTaxGstMaps: getCoaNonTaxGstMapsReducer,
  gstInvoices: getGstInvoicesReducer,
  gstInvoiceResponse: getGstInvoiceResponseReducer,
  findGstInvoice: findGstInvoiceReducer,

  //---------------------- PHASE-3 END ----------------------//
});


const findUser =
  secureLocalStorage.getItem(`uinfo`)
    ?
    JSON.parse(secureLocalStorage.getItem(`uinfo`))
    :
    null;

let user;

if (findUser) {
  user = {
    loading: false,
    isAuthenticated: findUser?.tokenDto?.accessToken !== "" ? true : false,
    userInfo: findUser?.userInfo,
    user: findUser?.tokenDto,
    menu: findUser?.menuResponseDtoList,
    userAgency: findUser?.agenciesModel,
    userRegionalOffice: findUser?.regionalOffice,
    dashboardList: findUser?.dashboardList,
    message: null
  };
}

let initialState = {
  user: user,
};

const middleware = [thunk];

// Root reducer that clears all state
const RootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = undefined;
  }

  return appReducer(state, action);
};

const store = createStore(
  RootReducer,
  initialState,
  applyMiddleware(...middleware)
);

export default store;
